import _Array$isArray from "core-js/library/fn/array/is-array.js";
export default function _arrayWithHoles(arr) {
  if (_Array$isArray(arr)) return arr;
}